












import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';

import { store } from '../../store/edit';


export default Vue.extend({
	name: 'ZakazkaSkupinaProfilSelect',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
